export default {
  'form.codeLabel': 'Please input your invitation code',
  'form.nameLabel': 'Please input your name',
  'form.nameMaxLenTips': `Within {maxLen} characters`,
  'form.incorrectCode': 'Incorrect invitation code!',
  'form.correctCode': 'Success!',
  'form.sameNameExist': 'The same name already exists',
  'form.submitFail': 'Submission Failed',
  'form.nameEditorTitle': 'Please input your name',
  'form.bulletDescription': 'Send a message to the screen',
  'form.bulletTurnOn': 'Please turn on the message function on the screen',
  'form.bulletPlaceholder': 'write your message',
  'form.cancel': 'Cancel',
  'form.confirm': 'Confirm',
  'form.notAllow': 'Special characters are not allowed',
};
